export default "__VITE_ASSET__$89IJ31q__"